<template>
  <div class="text-xs-center">
    <v-container fluid>
         <v-layout row>
            <v-flex xs6 order-lg2>
                <v-card dark tile flat color="green lighten-2">
                    <v-card-text style="font-size: 25px;"> 
                        <p>الوقت التنازلي </p>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs6 >
                <v-card dark tile flat color="green lighten-2">
                    <v-card-text style="font-size: 25px;">
                      <p>الاشارة</p>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <v-layout row>
            <v-flex xs6 order-lg2>
                <v-card dark tile flat color="green lighten-3">
                    <v-card-text style="font-size: 45px;"> 
                        <p>{{ countGreen}} </p>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs6 >
                <v-card dark tile flat color="green lighten-4">
                    <v-card-text >
                     <v-btn fab dark large  :color="success">
                    </v-btn>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
         <v-layout row>
            <v-flex xs6 order-lg2>
                <v-card dark tile flat color="green lighten-3">
                    <v-card-text style="font-size: 45px;">  
                        <p> {{countRed}}</p>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs6>
                <v-card dark tile flat color="green lighten-4">
                    <v-card-text>
                    <v-btn fab dark large  :color="error"/>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
         <v-layout row>
            <v-flex xs6 order-lg2>
                <v-card dark tile flat color="green lighten-1">
                    <v-card-text style="font-size: 21px;">
                         <v-layout row>
                            <v-flex xs4>
                                <v-btn icon @click="rol = rol + Math.floor(Math.random() * 20) + 5">
                                    <v-icon>add</v-icon>
                                </v-btn>
                            </v-flex>
                            <v-flex xs4>
                                <p> عدد الحجاج </p> 
                            </v-flex>
                            <v-flex xs4>
                                <v-btn icon @click="rol = rol - Math.floor(Math.random() * 20) + 5">
                                    <v-icon>remove</v-icon>
                                </v-btn>
                            </v-flex>
                         </v-layout>
                        </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs6>
                <v-card dark tile flat color="green lighten-3 ">
                    <v-card-text style="font-size: 28px;" >{{ countHajj }}</v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <!-- <p>{{Traffic}}</p> -->
        <v-container>
            <v-layout row wrap>
                <v-flex xs12 xs6 >
                    <!-- <v-jumbotron dark src="@/assets/a.png" />
                    <v-parallax src="@/assets/a.png" height="200"></v-parallax> -->
                    <!-- <v-parallax src="@/assets/a.png" /> -->
                    <img src="@/assets/a.png" width="100%" style="padding: 30px;">
                </v-flex>
                <v-flex xs2>
                    <p> x:   الزحمة</p>
                </v-flex>
                <v-flex xs2>
                    <p> n:  عدد الحجاج</p>
                </v-flex>
                <v-flex xs2>
                    <p> y:  الطول</p>
                </v-flex>
                <v-flex xs2>
                    <p> q:  العرض</p>
                </v-flex>
                <v-flex xs2>
                    <p> z:  الزمن</p>
                </v-flex>
                <v-flex  xs4>
                    <v-text-field
                        v-model="time1"
                        label="الزمن"
                        placeholder="قيمة الزمن بالثانية"
                        hint="الزمن الذي يستغرقه الحاج من بداية المرور إلي آخرة"
                        suffix="ثانية"
                        persistent-hint
                        outline
                    ></v-text-field>
                </v-flex>
                <v-flex  xs4>
                    <v-text-field
                        v-model="array1"
                        label="الطول"
                        placeholder="قيمة الطول بالمتر"
                        hint="طول الممر الذي يكفي لمرور الحجاج من خلاله."
                        suffix="متر"
                        persistent-hint
                        outline
                    ></v-text-field>
                </v-flex>
                <v-flex  xs4>
                    <v-text-field
                        v-model="array2"
                        label="العرض"
                        placeholder="قيمة المسافة بالمتر"
                        hint="عرض الممر الذي يكفي لمرور الحجاج من خلاله."
                        suffix="متر"
                        persistent-hint
                        outline
                    ></v-text-field>
                </v-flex>
            </v-layout>
        </v-container>
    </v-container>    
  </div>
</template>

<script>
export default {
  name: 'trafic',
  props: {
  },
  data: () => ({
    rol: Math.floor(Math.random() * 3) + 1,
    countHajj: Math.floor(Math.random() * 20) + 1,
    countGreen: 0,
    countRed: "متاح",
    array1: 100,
    array2: 100,
    time1: 100,
    Traffic:0
  }),
  timers: {
    log: { time: Math.floor(Math.random() * 1000) + 250 , repeat:true, autostart: true },
    countTGreen:{ time: 1000 , repeat:true, autostart: true },
    // countTRed:{ time: 1000 , repeat:true, autostart: true }
  },
  methods: {
    log () {
        this.$timer.stop('log')
        this.timers.log.time = Math.floor(Math.random() * 3000) + 0
        this.$timer.start('log')
        if(this.countHajj > 0){
            this.countHajj = this.countHajj + this.rol
            this.Traffic = parseInt(( (this.countHajj * this.time1) / (this.array1 * this.array2)) * 100) //(this.array1) / ( this.countHajj * 2 )//(this.countHajj * this.array1 ) /  this.time1
        }
        /* eslint-disable */
        console.log('Hello world:' + JSON.stringify( this.timers ) + "rol:"+this.rol) 
        // console.log('Hello world')
    },
    countTGreen () {
        if(this.Traffic  >= 50) {
            this.$timer.stop('log')
            if(this.countGreen == 0){
                this.countGreen = 11
            }
            if(this.countGreen > 0) {
                if(this.countGreen == 1){
                    this.Traffic = 77
                    this.$timer.start('log')
                    this.$timer.stop('countTGreen')
                }
                this.countGreen = this.countGreen - 1
            }
        }
    }
    // countTRed () {
    //     // if(this.Traffic  <= 65) {
    //     // {
    //     //     if(this.countRed == 0)
    //     //         this.countRed = 11
    //     //     if(this.countRed > 0)
    //     //         this.countRed = this.countRed -1
    //     // }
    //     this.countRed = "0"
    // }
  },
  computed: {
    success: function () {
        if(this.Traffic  < 75)
            return "success" // "success"
        else
            return  "grey lighten-2" 
    },
    error: function () {
        if(this.Traffic  >= 75){
            this.countRed = "ممتلئ"
            //if(this.Traffic  >= 100){
                this.$timer.stop('log')
            //}
            return "error" // "success"
        }
        else
            return  "grey lighten-2" 
        // return  // "error"
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* .v-label {
    font-size: 36px;
}
.v-text-field__slot {
    margin-left: 190px;
} */
.application .theme--dark.v-card, .theme--dark .v-card {
    background-color: #424242;
    color:black;
}
</style>
